import type { FC } from "react";

import { Container } from "~/shared/ui-kit/container/Container";
import { Flex } from "~/shared/ui-kit/flex/Flex";
import { Image } from "~/shared/ui-kit/image";
import { Title } from "~/shared/ui-kit/title/Title";

import type { MainBannerV2Props } from "../MainBannerV2";
import { MainBannerButtons } from "./MainBannerButtons";
import { MainBannerRowItems } from "./MainBannerRowItems";

export const Row: FC<MainBannerV2Props> = (props) => {
  const { getImageUrl, data } = props;
  return (
    <Flex
      as="section"
      flexDirection="column"
      justify="center"
      md={{ align: "flex-start" }}
      className="pt-8 pb-6  md:py-[104px] mx-auto px-4  max-w-[1240px] min-h-[500px] max-h-[580px]"
    >
      <Title
        as="h2"
        size="large"
        weight="bold"
        className="bg-golden-gradient bg-clip-text text-transparent mb-2 md:mb-8 text-center"
      >
        {props.data?.title}
      </Title>

      <Container
        align="center"
        justify="center"
        flexDirection="column"
        className="mb-8 md:mb-[60px]"
        md={{
          align: "center",
          flexDirection: "row",
          gap: 32,
          justify: "space-between",
        }}
      >
        <MainBannerRowItems {...props} />
        <Image value={getImageUrl(data.image?.id ?? "", { format: "webp" })} />
      </Container>

      <MainBannerButtons {...props} bannerVariant="row" />
    </Flex>
  );
};
